import { Brand } from 'effect'

export type MarketingListMemberId = string & Brand.Brand<'MarketingListMemberId'>

export const MarketingListMemberId = {
  make: Brand.nominal<MarketingListMemberId>(),
}
